export const subGruboFilterTipoTroca = arraySubGrupo => {
    const subgruposTrocaEquivalentes = arraySubGrupo.filter(subGrp => subGrp.troca).map(subGrp => subGrp.subgrupoTroca?.trim());

    const subGruposSemTroca = arraySubGrupo.filter(subGrp => !subgruposTrocaEquivalentes.includes(subGrp.plano.trim()));

    return subGruposSemTroca;
};
